import React, { useEffect, useState } from "react"

import { Row, Col } from "reactstrap"

// Pages Components
import Miniwidget from "./Miniwidget"
import ProfileViews from "./profileViews"
import Reach from "./reach"
import Impressions from "./impressions"
import Notifications from "./notifications"
import Inbox from "./inbox"
import RecentActivity from "./recent-activity"
import WidgetUser from "./widget-user"
import { useSelector, useDispatch, connect } from "react-redux"
import YearlySales from "./yearly-sales"
import LatestTransactions from "./latest-transactions"
import LatestOrders from "./latest-orders"
import PostsList from "./posts_list"

//Import Action to copy breadcrumb items from local state to redux state
import { setBreadcrumbItems } from "../../store/actions"
import SnackbarComponent from "components/SnackBar"
import axios from "axios"
import PostDetails from "./PostDetails"
import Chat from "./chat"
import CreatePost from "./CreatePost"
import config from "config/config"

const FacebookDashboard = props => {
  const { organizations, isConsolidatedView } = useSelector(
    state => state.organizationReducer,
  )
  const [pageDetails, setPageDetails] = useState(null)
  const [err, setErr] = useState(null)
  const [loadingInsights, setLoadingInsights] = useState(false)
  const [loadingPosts, setLoadingPosts] = useState(false)
  const [reviews, setReviews] = useState([])
  const [postClicked, setPostClicked] = useState(false)
  const [viewMode, setViewMode] = useState("Month")
  const [fromDate, setFromDate] = useState("")
  const [toDate, setToDate] = useState("")
  const [selectedPost, setSelectedPost] = useState(null)
  const [posts, setPosts] = useState([])
  const [reports, setReports] = useState([])
  const [success, setSuccess] = useState(null)
  const activeOrganization = useSelector(
    state => state.organizationReducer.activeOrganization,
  )
  const userData = useSelector(state => state.Login.userData)

  document.title = "Dashboard | AeraVue"

  const breadcrumbItems = [
    {
      title: `${activeOrganization.name} (${activeOrganization.type})`,
      link: "/dashboard",
    },
    { title: "Instagram", link: "#" },
  ]

  const [syncing, setSyncing] = useState(false)
  const [syncKey, setSyncKey] = useState(0)

  const getOrganizationIds = () =>
    isConsolidatedView
      ? organizations.map(org => org.Organization.id)
      : [activeOrganization.id]

  const fetchInstagramInsights = async (force = false) => {
    try {
      setLoadingInsights(true)

      const params = {
        organizationIds: getOrganizationIds().join(","),
        viewMode,
        force,
      }
      if (viewMode === "Custom") {
        params.fromDate = fromDate
        params.toDate = toDate
      }

      const resp = await axios.get(
        `${config.backendUrl}/instagram/dashboard/insights`,
        {
          params,
          headers: { Authorization: `Bearer ${userData.token}` },
          skipLoader: true,
        },
      )

      setReports(resp.data.reports)
      setLoadingInsights(false)
    } catch (error) {
      console.error("Error fetching Instagram insights:", error)
      setErr("Error fetching Instagram insights.")
      setLoadingInsights(false)
    }
  }

  const fetchPosts = async (force = false) => {
    try {
      setLoadingPosts(true)

      const resp = await axios.get(
        `${config.backendUrl}/instagram/dashboard/posts`,
        {
          params: { organizationIds: getOrganizationIds().join(","), force },
          headers: { Authorization: `Bearer ${userData.token}` },
          skipLoader: true,
        },
      )

      setPosts(resp.data.posts)
      setLoadingPosts(false)
    } catch (err) {
      console.error("Fetch posts error:", err)
      setErr("Error fetching posts.")
      setLoadingPosts(false)
    }
  }

  const handleSync = async () => {
    setSyncing(true)
    setSyncKey(k => k + 1)
    try {
      await Promise.all([fetchInstagramInsights(true), fetchPosts(true)])
    } finally {
      setSyncing(false)
    }
  }

  useEffect(() => {
    props.setBreadcrumbItems(`Instagram`, breadcrumbItems)
    fetchPosts()
  }, [activeOrganization, isConsolidatedView, organizations])

  useEffect(() => {
    fetchInstagramInsights()
  }, [viewMode, activeOrganization, isConsolidatedView, organizations])

  return (
    <React.Fragment>
      <SnackbarComponent
        err={err}
        success={success}
        setErr={setErr}
        setSuccess={setSuccess}
      />
      {postClicked ? (
        <PostDetails
          post={selectedPost}
          setErr={setErr}
          setSuccess={setSuccess}
          setPostClicked={setPostClicked}
          setSelectedPost={setSelectedPost}
        />
      ) : (
        <>
          <Miniwidget
            reports={reports}
            setViewMode={setViewMode}
            viewMode={viewMode}
            loading={loadingInsights}
            callBack={fetchInstagramInsights}
            fromDate={fromDate}
            toDate={toDate}
            setFromDate={setFromDate}
            setToDate={setToDate}
            onSync={handleSync}
            syncing={syncing}
          />

          <Row>
            <Col xl="12">
              <Reach
                reviews={reviews}
                loading={loadingInsights}
                syncKey={syncKey}
              />
            </Col>
          </Row>

          <Row>
            <Col xl="12">
              <ProfileViews syncKey={syncKey} />
            </Col>
          </Row>

          <Row>
            <Col xl={12}>
              <PostsList
                loading={loadingPosts}
                posts={posts}
                isConsolidatedView={isConsolidatedView}
                setPostClicked={setPostClicked}
                setSelectedPost={setSelectedPost}
              />
            </Col>
          </Row>
        </>
      )}
    </React.Fragment>
  )
}

export default connect(null, { setBreadcrumbItems })(FacebookDashboard)